import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const ReservationsWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
    padding: 40px;
    flex-direction: column;
  }

  .section {
    width: 100%;
    height: 540px;
    overflow: hidden;
    margin: 0 12px;
    margin-bottom: 20px;
    padding: 12px;
    border-radius: 32px;
    border: 1px solid ${mainColors.main_color};
    box-shadow: 0px 0px 20px 1px black;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      height: 400px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      height: 460px;
    }
    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      height: 380px;
    }
  }

  .time-section {
    overflow-y: scroll !important;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .rdp-months {
    --rdp-day-height: 55px;
    --rdp-nav-height: 60px;
    max-width: 100%;

    .rdp-month {
      width: 100%;
    }

    .rdp-weekdays {
      color: ${mainColors.main_color};
      --rdp-weekday-opacity: 1;
    }
  }

  .rdp-month_grid {
    width: 100%;
    font-size: ${sizeStandards.font.XL}px;
    border-top: 1px solid ${mainColors.main_color};
    border-collapse: initial;
    --rdp-weekday-padding: 32px 0;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      font-size: ${sizeStandards.font.MD}px;
      --rdp-weekday-padding: 24px 0;
      --rdp-day-height: 36px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      font-size: ${sizeStandards.font.XL}px;
      --rdp-day-height: 44px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      font-size: ${sizeStandards.font.MD}px;
      --rdp-day-height: 32px;
    }

    .rdp-day_button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      /* &:focus-visible {
        outline: none;
      } */
    }

    .rdp-selected {
      position: relative;
      border: none;
      font-size: ${sizeStandards.font.LG}px;

      .rdp-day_button {
        border: none;

        &::after {
          content: '';
          position: absolute;
          width: 36px;
          height: 36px;
          padding: 4px;
          box-shadow: 0px 0px 20px 1px ${mainColors.text_color};
          border-radius: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;

          @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
            width: 28px;
            height: 28px;
          }
        }
      }
    }
  }

  .rdp-footer {
    position: absolute;
    top: 520px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;

    @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
      top: 380px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      top: 440px;
    }

    @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
      top: 365px;
    }
  }
`;

export default ReservationsWrapper;
